import { gql } from "@/gql";

/**
 * GraphQL subscription for real-time configuration updates
 *
 * Features:
 * - Real-time updates when configurations change
 * - Optional filtering by specific configuration keys
 * - Optional filtering by configuration categories
 * - Includes metadata about what changed and when
 */
export const SALON_CONFIGURATION_SUBSCRIPTION = gql(`
  subscription SalonConfigurationUpdated($filters: ConfigurationSubscriptionFilterInput!) {
    salonConfigurationUpdated(filters: $filters) {
      event
      salonId
      configurations {
        key
        value
        dataType
        category
        createdAt
        updatedAt
      }
      changedKeys
      userId
      timestamp
    }
  }
`);

/**
 * Input type for configuration subscription filters
 */
export interface ConfigurationSubscriptionFilters {
  salonId: string;
  keys?: string[];
  categories?: string[];
}
